export default "__VITE_ASSET__DYe3bSYh__"